import { render, staticRenderFns } from "./VerifyDia.vue?vue&type=template&id=55e854fa"
import script from "./VerifyDia.vue?vue&type=script&lang=js"
export * from "./VerifyDia.vue?vue&type=script&lang=js"
import style0 from "./VerifyDia.vue?vue&type=style&index=0&id=55e854fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports